// Ordinea oficială a categoriilor PSA (afișare uniformă în toate vizualizările):
// 1. mască  2. furtun  3. curea  4. cizme  5. hanorac  6. tricou  7. geacă  8. pantaloni  9. bocanci  10. altele
export const PSA_CATEGORY_ORDER = [
  "masca",
  "furtun",
  "curea",
  "casca",
  "cizme",
  "hanorac",
  "tricou",
  "geaca",
  "pantaloni",
  "bocanci",
  "altele",
];

// Index pentru sortare rapidă (categorie necunoscută → la final)
export const psaCatRank = (cat) => {
  const idx = PSA_CATEGORY_ORDER.indexOf(cat || "altele");
  return idx === -1 ? PSA_CATEGORY_ORDER.length : idx;
};

// Ordinea oficială pentru mărimi text (haine/hanorace/tricouri).
// XS < S < M < L < XL < XXL < XXXL ...
export const PSA_SIZE_TEXT_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "4XL", "5XL"];

/**
 * Rank numeric pentru sortarea mărimilor PSA în ordine CRESCĂTOARE.
 *  - „XS"…„XXL" → folosește PSA_SIZE_TEXT_ORDER
 *  - numerice (cizme, bocanci: 38, 39, 40 …) → valoarea numerică
 *  - „—" / null → la sfârșit
 *
 * Returnează un număr (cu cât mai mic, cu atât „mai mic" în UI).
 */
export const psaSizeRank = (size) => {
  if (!size) return Number.POSITIVE_INFINITY;
  const s = String(size).trim().toUpperCase();
  const idx = PSA_SIZE_TEXT_ORDER.indexOf(s);
  if (idx !== -1) return idx;
  // încearcă numeric (ex: „42" pentru cizme/bocanci)
  const n = parseFloat(s.replace(",", "."));
  if (!Number.isNaN(n)) {
    // offset pozitiv mare ca să fie sortate după textele cu XXL etc.
    // — dar în practică un set are doar text SAU doar numere, deci nu se amestecă.
    return n;
  }
  return Number.POSITIVE_INFINITY;
};

// Comparator pentru sortarea unei liste de items PSA după categorie (apoi după nume, ca tie-break)
export const psaItemComparator = (a, b) => {
  const ra = psaCatRank(a?.psa_category);
  const rb = psaCatRank(b?.psa_category);
  if (ra !== rb) return ra - rb;
  return String(a?.name || "").localeCompare(String(b?.name || ""));
};

/**
 * Comparator pentru afișarea în PSA: STOC PRIMUL (rândurile neasignate), apoi
 * alocările către angajați. În ambele bucle, sortare după mărime CRESCĂTOR,
 * apoi după nume.
 */
export const psaStockFirstComparator = (a, b) => {
  const aAssigned = a?.assignee_person_id ? 1 : 0;
  const bAssigned = b?.assignee_person_id ? 1 : 0;
  if (aAssigned !== bAssigned) return aAssigned - bAssigned; // stoc (0) < alocat (1)
  const ra = psaSizeRank(a?.psa_size);
  const rb = psaSizeRank(b?.psa_size);
  if (ra !== rb) return ra - rb;
  return String(a?.name || "").localeCompare(String(b?.name || ""));
};
